var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.percentValue,"type":"number","rules":[function (v) { return (v >= 0 && v <= 100) || '無効'; }],"readonly":_vm.readonly},on:{"input":_vm.emitInput}})}
var staticRenderFns = []

export { render, staticRenderFns }